(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports', [])
      .constant('ReportFormat', {
        Daily: 'daily',
        Weekly: 'weekly',
        Monthly: 'monthly'
      })
      .constant('MIN_DATE', moment(new Date('10/01/2020')).format('YYYY-MM-DD'))
      .constant('MAX_CONVERSION', 100)
      .constant('ConsumerChartDisplay', {
        'Colors' : {  // key & arr of stroke & fill color
          'tfLine': { stroke: '#4a90e1', fill: '#5A9AE4', opacity: 'none' , class: 'tf-color'},
          'nonTFLine': { stroke: '#f4a622', fill: '#927852', opacity: 'none', class: 'nontf-color'},
          'botLine' : { stroke: '#727479', fill: '#5b5d64', opacity: '0.5', class: 'bot-color'},
          'totalLine' : { stroke: '#C4C4C5', fill: '#5C5E65', opacity: '0.5', class: 'sitewide-color'},
          'registered' : { stroke: '#4169E1', fill: '#4169E1', opacity: '0.5', class: 'registered-color'},
          'siteRegistered' : { stroke: '#569AE1', fill: '#569AE1', opacity: 'none', class: 'site-registered-color'},
          'travellingRegistered' : { stroke: '#437BB2', fill: '#437BB2', opacity: '0.5', class: 'traveling-registered-color'},
          'ipRegistered' : { stroke: '#35628C', fill: '#35628C', opacity: '0.5', class: 'ip-registered-color'}
        }
      })
      .constant('StandardReportPrivileges', ['report.TransactionAndImpact'])
      .directive('extendedTfcMainNav', function (tfcMainNavDirective) {
        //creating a copy of the existing tfcNav and changing the templateUrl to the store reporting nav template
        var tfcMainNav = angular.copy(tfcMainNavDirective[0]);
        tfcMainNav.templateUrl = 'StandardReports/Nav/StoreNav.tmpl.html';
        return tfcMainNav;
      });

})();